export const ROUTES_CORE = {
  HOME: '/',
  LOGOUT: '/logout',
  LOGIN: '/login',
  REGISTER: `/register`,
  RESET_PASSWORD: (token: string) => `/reset-password/${token}`,
  FORGOT_PASSWORD: '/forgot-password',
};

export const ROUTES_DASHBOARD = {
  DASHBOARD: '/dashboard',
  STATISTICS: '/dashboard/statistics',
  STATISTICS_SURVEY: '/dashboard/statistics/survey',
  DETAILS: (type: string) => `/dashboard/${type}`,
};

export const ROUTES_USERS = {
  LIST: '/users',
  ADD: `/users/add`,
  EDIT: (id: string) => `/users/${id}/edit`,
  DETAILS: (id: string) => `/users/${id}/details`,
};

export const ROUTES_SURVEY = {
  DETAILS: (id: string) => `/surveys/${id}`,
  DETAILS_EXTENDED: (id: string, section: string) => `/surveys/${id}/${section}`,
  DETAILS_FULL_EXTENDED: (id: string, section: string, element?: string) => `/surveys/${id}/${section}/${element}`,
  DATA_DOWNLOAD: (id: string) => `/surveys/data/${id}/download`,
};

export const ROUTES_COMMENTS = {
  LIST: '/comments',
  ADD: `/comments/add`,
  EDIT: (id: string) => `/comments/${id}/edit`,
  DETAILS: (id: string) => `/comments/${id}/details`,
};
